import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import { CanvasEventType, GraphType } from '../constants/Constants';
import log from 'loglevel';
import CanvasPen from './CanvasPen';

/**
 * 荧光笔
 *
 * @export
 * @class CanvasNitePen
 * @extends {Graphic}
 * @author zhenliang.sun
 */
export default class CanvasNitePen extends CanvasPen {
  constructor(app) {
    super(app);
    this.e = {
      [CanvasEventType.Add]: this._addHandler.bind(this)
    };
  }

  get option() {
    return this._option;
  }

  set option(val) {
    super.option = val;

    if (!val) {
      this._option = this.defaultOption;
    }

    Object.assign(this._option, val);
  }

  get defaultOption() {
    let opt = super.defaultOption;
    opt.stroke = '#80FF80';
    opt.blurStroke = '#80FF00';
    return opt;
  }

  addEvents() {
    this.root.isDrawingMode = true;
    let brush = this.root.freeDrawingBrush;
    brush.color = this.option.stroke;
    brush.width = Math.max(this._option.strokeWidth, 1);
    brush.shadow = CanvasNitePen.createShadow(this.option.blurStroke);

    this.root.on(CanvasEventType.Add, this.e[CanvasEventType.Add]);
  }

  _addHandler(e) {
    log.info('add', e);
    if (!e.target) {
      return;
    }

    let item = e.target;
    // 这里跟普通的画笔是一样的，然后进行渐隐操作，最后移除
    let data = this.factory.createAddData(item);
    // MsgSender.add(data)
    this.app.sender.add(data);
    item.animate('opacity', 0, {
      duration: 1000,
      onChange: this.root.renderAll.bind(this.root),
      onComplete: () => {
        this.root.remove(item);
      }
    });
  }

  removeEvents() {
    super.removeEvents();
    this.root.off(CanvasEventType.Add, this.e[CanvasEventType.Add]);
  }

  static toAddData(target) {
    let obj = CanvasPen.toAddData(target);
    obj.gtype = GraphType.NITE_WHITE_PEN;
    obj.blurStroke = '#80FF00';
    return obj;
  }

  /**
   * 赋值
   *
   * @static
   * @param {any} item
   * @param {any} data
   * @memberof CanvasNitePen
   */
  static drawFromData(item, data) {
    // item.shadow = CanvasNitePen.createShadow(data.blurStroke)
    // item.animate('opacity', 0, {
    //   duration: 1000,
    //   onChange: this.root.renderAll.bind(this.root),
    //   onComplete: () => {
    //     this.root.remove(item)
    //   }
    // })
  }

  static createShadow(color) {
    return new fabric.Shadow({
      // blur: 10,
      offsetX: 0,
      offsetY: 0,
      color: color
    });
  }
}
